/**
 * DrawerComponent — drawer latéral droit réutilisable.
 *
 * Déclenchement : tout bouton avec data-drawer-trigger="<id-du-drawer>".
 * Fermeture     : backdrop, bouton data-drawer-close, touche Escape.
 *
 * Plusieurs drawers peuvent coexister sur la page ; chacun est indépendant.
 */
class DrawerComponent extends HTMLElement {
  connectedCallback() {
    this._backdrop = this.querySelector("[data-drawer-backdrop]");
    this._panel = this.querySelector("[data-drawer-panel]");

    this._backdrop?.addEventListener("click", () => this.close());

    this.querySelectorAll("[data-drawer-close]").forEach((btn) => {
      btn.addEventListener("click", () => this.close());
    });

    this._onKeydown = (e) => {
      if (e.key === "Escape") this.close();
    };

    this._onDocClick = (e) => {
      const trigger = e.target.closest("[data-drawer-trigger]");
      if (trigger && trigger.dataset.drawerTrigger === this.id) {
        this._triggerEl = trigger;
        this.open();
      }
    };

    document.addEventListener("click", this._onDocClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._onDocClick);
    document.removeEventListener("keydown", this._onKeydown);
  }

  open() {
    this.setAttribute("data-open", "");
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this._onKeydown);

    // Focus sur le premier élément focusable dans le panel.
    requestAnimationFrame(() => {
      const focusable = this._panel?.querySelector(
        'button:not([disabled]), [href], input, [tabindex]:not([tabindex="-1"])'
      );
      focusable?.focus();
    });

    this.dispatchEvent(new CustomEvent("drawer:open", { bubbles: true }));
  }

  close() {
    this.removeAttribute("data-open");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this._onKeydown);

    // Rend le focus au bouton déclencheur.
    this._triggerEl?.focus();
    this._triggerEl = null;

    this.dispatchEvent(new CustomEvent("drawer:close", { bubbles: true }));
  }

  get isOpen() {
    return this.hasAttribute("data-open");
  }
}

customElements.define("drawer-component", DrawerComponent);
